import { render, staticRenderFns } from "./blockListingSimple.vue?vue&type=template&id=6a50412f&scoped=true"
import script from "./blockListingSimple.vue?vue&type=script&lang=js"
export * from "./blockListingSimple.vue?vue&type=script&lang=js"
import style0 from "./blockListingSimple.vue?vue&type=style&index=0&id=6a50412f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50412f",
  null
  
)

export default component.exports